/** @jsx jsx */
/** @jsxFrag null */
import {jsx} from 'panel';

import {ModalEl} from 'common/components/modal';
import {SvgIconEl} from 'common/components/svg-icon';
import type {OrgSelectModal} from 'common/widgets/org-select-modal/index';

export function template(this: OrgSelectModal) {
  const {orgs, submitted} = this.state;

  return (
    <div sel='.select-org-modal-container'>
      <ModalEl
        sel='.select-org-modal'
        attrs={{
          closeable: this.attr(`show-cancel`),
          open: this.attr(`open`) && !submitted,
        }}
        on={{submit: this.helpers.handleSubmit}}
      >
        <div sel='.mp-card-header'>
          <div sel='.mp-card-header-title'>{this.attr(`title-text`)}</div>
        </div>
        <div sel='.action-text'>{this.t(`org-select-modal.select-organization`)}</div>
        <div sel='.input-area'>
          {orgs ? (
            orgs.map((org) => (
              <div sel='.org-card' on={{click: () => this.helpers.selectOrg(org)}}>
                <div sel='.org-card-container'>
                  <div sel='.org-name'>{org.name}</div>
                  <div sel='.caret-icon'>
                    <SvgIconEl attrs={{icon: `caret-right`}} />
                  </div>
                </div>
              </div>
            ))
          ) : (
            <>
              <div sel='.mp-skeleton-small' />
              <div sel='.mp-skeleton-small' />
              <div sel='.mp-skeleton-small' />
              <div sel='.mp-skeleton-small' />
            </>
          )}
        </div>
      </ModalEl>
    </div>
  );
}
